
<template>
  <div class="flex justify-end" :class="isDarkMode ? 'text-app-color' : 'text-dark-600'">
    <DropdownModule
      :width="180"
      button-classes="py-7 px-10"
      append-to-body
      remove-optional-top-gap
      :background="isDarkMode ? 'bg-sidebar' : 'bg-white'"
      position-menu="left"
      top-position="30px"
    >
      <template #button="{isOpen}">
        <div class="flex items-center cursor-pointer">
          <div v-if="selectedMember" class="flex items-center flex-wrap">
            <div class="flex items-center text-app-color rounded-6 py-1 px-7"
                 :class="isDarkMode ? 'bg-book' : 'bg-white shadow-user-badge border border-grey-500'"
            >
              <UserBadge
                :first-name="selectedMember.user.profile.firstName"
                :last-name="selectedMember.user.profile.lastName"
                :color="selectedMember.user.profile.color"
                color-height="h-15"
              />

              <i v-if="showCloseIcon || isOpen" class="icon-close text-10 opacity-50 hover:opacity-100 anim-opacity ml-5" @click.stop="assignMember(selectedMember)" />
            </div>
          </div>

          <i v-else class="icon-mention-member text-20 opacity-30 hover:opacity-50 anim-opacity" />
        </div>
      </template>

      <div class="max-h-300 overflow-y-auto text-13">
        <div
          v-for="member in members"
          :key="member.id"
          class="hover:bg-selection group-scope last:rounded-b-10 first:rounded-t-10 text-app-color cursor-pointer"
        >
          <div class="text-app-color rounded-6 py-6 px-10" @click.stop="assignMember(member)">
            <UserBadge
              :first-name="member.firstName"
              :last-name="member.lastName"
              :color="member.color"
              color-height="h-18"
            >
              <template #button>
                <i v-if="selectedMember && selectedMember.id === member.id" class="icon-check_mark text-18" />
              </template>
            </UserBadge>
          </div>
        </div>
      </div>
    </DropdownModule>
  </div>
</template>

<script>
import { defineComponent, computed, ref } from 'vue'
import { useStore } from 'vuex'

import DropdownModule from '@/components/shared/form-controls/DropdownModule'
import UserBadge from '@/components/shared/UserBadge'

export default defineComponent({
  components: { DropdownModule, UserBadge },

  props: {
    selectedMember: Object,
    bookId: Number,
    showCloseIcon: { type: Boolean, default: false }
  },

  emits: ['assignMember'],

  setup (props, { emit }) {
    const { state, getters } = useStore()

    const show = ref(false)

    const isDarkMode = computed(() => getters.isDarkMode)
    const headquarters = computed(() => state.team.headquarters)
    const isTeamAccount = computed(() => getters.isTeamAccount)

    const members = computed(() => {
      if (isTeamAccount.value && headquarters.value.id === props.bookId) return state.team.members
      const book = state.book.books.find(b => b.id === props.bookId)
      return book.shareWith
    })

    function showDropdown () {
      show.value = true
    }

    function assignMember (value) {
      let member = null

      if (value?.id !== props.selectedMember?.id) {
        member = {
          id: value.id,
          user: {
            profile: {
              firstName: value.firstName,
              lastName: value.lastName,
              color: value.color
            }
          }
        }
      }

      emit('assignMember', member)
    }

    return {
      // data
      show,
      // computed
      isDarkMode,
      members,
      // functions
      showDropdown,
      assignMember
    }
  }
})
</script>
